<app-loading *ngIf="contentReady"></app-loading>

<div class="bb-page">
  <div class="bb-page-shell">
    <!-- Header -->
    <div class="bb-page-header">

      <div class="bb-page-title-block">
                               <span class="bb-eyebrow">{{ 'invoices' | transloco }}</span>
        <h2 class="bb-page-title">{{ "invoices" | transloco }}</h2>
        <p class="bb-page-subtitle">{{ "manage invoices" | transloco }}</p>
      </div>

      <div class="bb-header-actions">

        @if (!isDeliveryHero) {
        <button class="bb-btn bb-btn-primary" (click)="checkWarehouseType()">
          {{ "add order" | transloco }}
        </button>
        }

        @if (isAdmin) {
        <div class="dropdown">
          <button class="bb-btn bb-btn-secondary dropdown-toggle" type="button" data-bs-toggle="dropdown">
            {{ "Pospage" | transloco }}
          </button>

          <ul class="bb-dropdown-menu dropdown-menu">
            <li *ngFor="let el of allWareHouses">
              <a class="bb-dropdown-item dropdown-item" (click)="applyWareHouse(el.id)">
                {{ el.name }}
              </a>
            </li>
          </ul>
        </div>
        }

        @if (!showoptions) {
        <button *ngIf="isAdmin" (click)="advancedSearch()" class="bb-btn bb-btn-secondary">
          {{ "advanced" | transloco }}
        </button>
        } @else {
        <button *ngIf="isAdmin" (click)="clearFilters()" class="bb-btn bb-btn-secondary">
          {{ "normal" | transloco }}
        </button>
        }

        @if (selectedDeliveryOrders.length !== 0) {
        <button routerLink="/deliveryorders" class="bb-btn bb-btn-secondary">
          {{ "ready for delivery" | transloco }}
        </button>
        }

        @if ((isAdmin || isSubAdmin) && isCompany) {
        <button class="bb-btn bb-btn-secondary" (click)="getTodyasOrders()">
          {{ "todays orders" | transloco }}
        </button>
        }

      </div>

    </div>


    <!-- Card -->
    <div class="bb-filter-card">

      <div class="search-row">

        @if (showoptions) {

        <!-- Search by invoice -->
        <div class="search-box">
          <input type="text" class="bb-input" [(ngModel)]="searchOrderId"
            placeholder="{{ 'invoice' | transloco }}">

          <button class="bb-btn bb-btn-primary" (click)="searchOrderbyId()">
            {{ 'Search' | transloco }}
          </button>
        </div>


        <!-- Order Status -->
        <div class="dropdown">
          <button class="bb-btn bb-btn-secondary dropdown-toggle" data-bs-toggle="dropdown">
            {{ "statusfilter" | transloco }}
          </button>

          <ul class="bb-dropdown-menu dropdown-menu">

            @if (usesSimpleOrderStatusFilter) {
            <li>
              <a class="bb-dropdown-item dropdown-item" (click)="applyStatusFilter(5,'order_status')">
                {{ "shipped" | transloco }}
              </a>
            </li>

            <li>
              <a class="bb-dropdown-item dropdown-item" (click)="applyStatusFilter(3,'order_status')">
                {{ "rejected" | transloco }}
              </a>
            </li>

            <li>
              <a class="bb-dropdown-item dropdown-item" (click)="applyStatusFilter(1,'order_status')">
                {{ "pending" | transloco }}
              </a>
            </li>
            } @else {
            <li>
              <a class="bb-dropdown-item dropdown-item" (click)="applyStatusFilter(1,'order_status')">
                {{ "pending" | transloco }}
              </a>
            </li>

            <li>
              <a class="bb-dropdown-item dropdown-item" (click)="applyStatusFilter(2,'order_status')">
                {{ "approved" | transloco }}
              </a>
            </li>

            <li>
              <a class="bb-dropdown-item dropdown-item" (click)="applyStatusFilter(3,'order_status')">
                {{ "rejected" | transloco }}
              </a>
            </li>

            <li>
              <a class="bb-dropdown-item dropdown-item" (click)="applyStatusFilter(4,'order_status')">
                {{ "on the way" | transloco }}
              </a>
            </li>

            <li>
              <a class="bb-dropdown-item dropdown-item" (click)="applyStatusFilter(5,'order_status')">
                {{ "shipped" | transloco }}
              </a>
            </li>

            <li>
              <a class="bb-dropdown-item dropdown-item" (click)="applyStatusFilter(6,'order_status')">
                {{ "Deferred" | transloco }}
              </a>
            </li>

            <li>
              <a class="bb-dropdown-item dropdown-item" (click)="applyStatusFilter(7,'order_status')">
                {{ "notcontacttheclient" | transloco }}
              </a>
            </li>

            <li>
              <a class="bb-dropdown-item dropdown-item" (click)="applyStatusFilter(8,'order_status')">
                {{ "delivered" | transloco }}
              </a>
            </li>

            }
          </ul>
        </div>


        <!-- Delivery Status -->
        @if (!usesSimpleOrderStatusFilter) {
        <div class="dropdown">

          <button class="bb-btn bb-btn-secondary dropdown-toggle" data-bs-toggle="dropdown">
            {{ "delivery status" | transloco }}
          </button>

          <ul class="bb-dropdown-menu dropdown-menu">

            <li>
              <a class="bb-dropdown-item dropdown-item" (click)="applyStatusFilter(1,'delivery_status')">
                {{ "delivery in progress" | transloco }}
              </a>
            </li>

            <li>
              <a class="bb-dropdown-item dropdown-item" (click)="applyStatusFilter(2,'delivery_status')">
                {{ "not delivered" | transloco }}
              </a>
            </li>

            <li>
              <a class="bb-dropdown-item dropdown-item" (click)="applyStatusFilter(3,'delivery_status')">
                {{ "delivered" | transloco }}
              </a>
            </li>

          </ul>

        </div>
        }

        }

        @else {

        <div class="search-box">

          <input type="text" class="bb-input" [(ngModel)]="searchKey"
            placeholder="{{ 'Phone Number' | transloco }}">

          <button class="bb-btn bb-btn-primary" (click)="search()">
            {{ 'Search' | transloco }}
          </button>

        </div>

        }

      </div>

    </div>

    <div class="bb-table-card">
      <div class="bb-table-scroll">
          <table mat-table id="orderstable" [dataSource]="dataSource" [trackBy]="trackById" class="bb-table">
            <!-- Client Name Column -->
            <!-- Client Info Column -->
            <ng-container matColumnDef="client_info">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
                {{ "client info" | transloco }}
              </th>

              <td mat-cell *matCellDef="let element" class="mat-cell-custom">

                <div class="bb-order-client-card">

                  <!-- Avatar -->
                  <div class="bb-client-avatar">
                    {{ element.client_name?.charAt(0) }}
                  </div>

                  <div class="bb-order-client-details">

                    <!-- Name -->
                    <div class="bb-order-client-name" matTooltip="{{ element.website_url ? element.website_url : '' }}">
                      {{ element.client_name }}
                    </div>

                    <!-- Phones -->
                    <div class="bb-order-client-phones">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M6.6 10.8C8.1 13.7 10.3 15.9 13.2 17.4L15.5 15.1C15.8 14.8 16.2 14.7 16.6 14.8C17.9 15.2 19.3 15.4 20.7 15.4C21.3 15.4 21.8 15.9 21.8 16.5V20.2C21.8 20.8 21.3 21.3 20.7 21.3C10.9 21.3 2.7 13.1 2.7 3.3C2.7 2.7 3.2 2.2 3.8 2.2H7.5C8.1 2.2 8.6 2.7 8.6 3.3C8.6 4.7 8.8 6.1 9.2 7.4C9.3 7.8 9.2 8.2 8.9 8.5L6.6 10.8Z"
                          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg> {{ element.phone_number }}
                      @if (element.another_phone) {
                      <span> | {{ element.another_phone }}</span>
                      }
                    </div>

                    <!-- Address -->
                    <div class="bb-order-client-address">
                      @if (element.grov_id) {
                      {{ element.governorate?.governorate_name_ar }} -
                      {{ element.city?.city_name_ar }} -
                      }
                      {{ element.address }}
                    </div>

                    <!-- Map -->
                    @if (element.order_location && element.order_location !== "null") {
                    <a class="bb-order-map-link" [href]="element.order_location" target="_blank">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 21C12 21 5 14.5 5 9.5C5 5.9 8.1 3 12 3C15.9 3 19 5.9 19 9.5C19 14.5 12 21 12 21Z"
                          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                        <circle cx="12" cy="9.5" r="2.5" stroke="currentColor" stroke-width="2.5" />
                      </svg> {{ 'map location' | transloco }}
                    </a>
                    }

                  </div>

                </div>

              </td>
            </ng-container>

            <!-- Order Details Column -->
            <ng-container matColumnDef="order_details">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
                {{ "order details" | transloco }}
              </th>

              <td mat-cell *matCellDef="let element" class="mat-cell-custom">

                <div class="bb-order-box">

                  <!-- Products List -->
                  <div class="bb-order-products-list">
                    <div class="bb-order-product-row" *ngFor="let item of tolist(element.item); let i = index">

                      <div class="bb-order-product-name">
                        {{ item }}
                      </div>

                      <div class="bb-order-product-meta">
                        <span class="bb-badge bb-badge-soft-blue">
                          x{{ tolist(element.quantity)[i] }}
                        </span>

                        <span class="bb-price">
                          {{ tolist(element.price)[i] }} {{ "egp" | transloco }}
                        </span>
                      </div>

                    </div>
                  </div>

                  <!-- Divider -->
                  <div class="bb-order-divider"></div>

                  <!-- Discount -->
                  @if (element.discount) {
                  <div class="bb-order-summary-row bb-order-discount-row">
                    <span>{{ "discount" | transloco }}</span>
                    <span>- {{ element.discount }} {{ "egp" | transloco }}</span>
                  </div>
                  }

                  <!-- Delivery -->
                  <div class="bb-order-summary-row">
                    <span>{{ "delivery" | transloco }}</span>
                    <span>{{ element.delivery_fees }} {{ "egp" | transloco }}</span>
                  </div>

                  <!-- Total -->
                  <div class="bb-order-summary-row bb-order-total-row">
                    <span>{{ "total" | transloco }}</span>
                    <span>{{ element.total }} {{ "egp" | transloco }}</span>
                  </div>

                </div>

              </td>
            </ng-container>
            <!-- Order Meta Column -->
            <ng-container matColumnDef="order_meta">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">

              </th>
              <td mat-cell *matCellDef="let element" class="mat-cell-custom">
                <div class="bb-order-meta-card">

                  <div class="bb-order-meta-item">
                    <span class="bb-order-meta-label">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="3" y="5" width="18" height="16" rx="3" stroke="currentColor" stroke-width="2.5"
                          stroke-linecap="round" stroke-linejoin="round" />

                        <line x1="3" y1="9" x2="21" y2="9" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />

                        <line x1="8" y1="3" x2="8" y2="7" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />

                        <line x1="16" y1="3" x2="16" y2="7" stroke="currentColor" stroke-width="2.5"
                          stroke-linecap="round" />
                      </svg> {{ "created at" | transloco }}
                    </span>
                    <span class="bb-order-meta-value">
                      {{ element.created_at | date: 'dd/MM/yyyy HH:mm' }}
                    </span>
                  </div>
                  @if(warehouseTypeService.isCompany()){
                  <div class="bb-order-meta-item">
                    <span class="bb-order-meta-label">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="8" r="4" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                          stroke-linejoin="round" />

                        <path d="M4 20C4 16.5 7.5 14 12 14C16.5 14 20 16.5 20 20" stroke="currentColor" stroke-width="2.5"
                          stroke-linecap="round" stroke-linejoin="round" />
                      </svg> {{ "created by" | transloco }}
                    </span>
                    <span class="bb-order-meta-value">
                      {{ element.user_last_name }}
                    </span>
                  </div>

                  <div class="bb-order-meta-item">
                    <span class="bb-order-meta-label">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <circle cx="12" cy="12" r="9" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                          stroke-linejoin="round" />

                        <path d="M12 6V18" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />

                        <path
                          d="M15.5 9C15.5 7.9 14 7 12 7C10 7 8.5 7.9 8.5 9C8.5 11 15.5 10.5 15.5 13C15.5 14.1 14 15 12 15C10 15 8.5 14.1 8.5 13"
                          stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" />
                      </svg> {{ "commission" | transloco }}
                    </span>
                    <span class="bb-order-meta-value bb-order-commission">
                      @if (element.duenow && element.duenow !== 'undefined') {
                      {{ element.duenow }} {{ "egp" | transloco }}
                      } @else {
                      {{ "admin" | transloco }}
                      }
                    </span>
                  </div>
                  }
                  @if (element.remaining > 0) {
                  <div class="bb-order-remaining-box">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M12 3L21 19H3L12 3Z" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                        stroke-linejoin="round" />

                      <line x1="12" y1="9" x2="12" y2="13" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" />

                      <circle cx="12" cy="17" r="1" fill="currentColor" />
                    </svg> {{ "not_payed" | transloco }} :
                    {{ element.remaining }} {{ "egp" | transloco }}
                  </div>
                  }

                  @if(element.delivery_hero != null)
                  {


                  <div class="bb-order-meta-item">
                    <span class="bb-order-meta-label">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">

                        <!-- truck body -->
                        <rect x="2" y="8" width="11" height="7" rx="2" stroke="currentColor" stroke-width="2.5"
                          stroke-linejoin="round" />

                        <!-- truck cabin -->
                        <path d="M13 10H17L21 13V15H13V10Z" stroke="currentColor" stroke-width="2.5"
                          stroke-linejoin="round" />

                        <!-- wheels -->
                        <circle cx="7" cy="17" r="2" stroke="currentColor" stroke-width="2.5" />

                        <circle cx="18" cy="17" r="2" stroke="currentColor" stroke-width="2.5" />

                      </svg> {{ "deliveryhero" | transloco }}
                    </span>
                    <span class="bb-order-meta-value bb-order-commission">
                      {{element.delivery_hero}}
                    </span>
                  </div>
                  }
                  <!-- Delivery Status -->
                  @if (element.delivery_hero != null && element.delivery_hero != '') {
                  <div class="bb-order-meta-item">

                    <span class="bb-order-meta-label">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">

                        <!-- truck body -->
                        <rect x="2" y="9" width="9" height="6" rx="2" stroke="currentColor" stroke-width="2.5"
                          stroke-linecap="round" stroke-linejoin="round" />

                        <!-- truck cabin -->
                        <path d="M11 11H15L18 13V15H11V11Z" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                          stroke-linejoin="round" />

                        <!-- wheels -->
                        <circle cx="6" cy="17" r="2" stroke="currentColor" stroke-width="2.5" />

                        <circle cx="15" cy="17" r="2" stroke="currentColor" stroke-width="2.5" />

                        <!-- check mark -->
                        <path d="M18.5 7.5L20 9L22.5 6.5" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                          stroke-linejoin="round" />

                      </svg> {{ "delivery status" | transloco }}
                    </span>

                    <span class="bb-order-meta-value bb-order-delivery-badge" [ngClass]="{
          'waiting': element.delivery_status == '0',
          'inprogress': element.delivery_status == '1',
          'notdelivered': element.delivery_status == '2',
          'delivered': element.delivery_status == '3'
        }">

                      <ng-container [ngSwitch]="element.delivery_status">

                        <span *ngSwitchCase="'0'">
                          {{ "waiting for delivery" | transloco }}
                        </span>

                        <span *ngSwitchCase="'1'">
                          {{ "delivery in progress" | transloco }}
                        </span>

                        <span *ngSwitchCase="'2'">
                          {{ "not delivered" | transloco }}
                        </span>

                        <span *ngSwitchCase="'3'">
                          {{ "delivered" | transloco }}
                        </span>

                      </ng-container>

                    </span>

                  </div>
                  }
                </div>
              </td>
            </ng-container>
            <ng-container matColumnDef="order_status">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom">
                {{ "status" | transloco }}
              </th>

              <td mat-cell *matCellDef="let element" class="mat-cell-custom">

                <!-- Partially Completed -->
                @if (element.ispartially_completed) {

                <div class="bb-order-status-card partial">

                  <div class="bb-order-status-header">
                    {{ "Partially completed" | transloco }}
                  </div>

                  @if (element.comment) {
                  <div class="bb-order-status-comment">
                    {{ element.comment }}
                  </div>
                  }

                  <div class="bb-order-payment-type">
                    {{ "payment_type" | transloco }} :
                    <span [ngSwitch]="element.payment_type">
                      <span *ngSwitchCase="'0'">{{ "cash" | transloco }}</span>
                      <span *ngSwitchCase="'1'">{{ "vodafone cash" | transloco }}</span>
                      <span *ngSwitchCase="'2'">{{ "instapay" | transloco }}</span>
                      <span *ngSwitchCase="'3'">{{ "online payment" | transloco }}</span>
                      <span *ngSwitchCase="'4'">{{ "bank transfer" | transloco }}</span>
                      <span *ngSwitchCase="'5'">{{ "credit" | transloco }}</span>
                    </span>
                  </div>

                  @if (element.remaining > 0) {
                  <div class="bb-badge bb-badge-danger bb-order-remaining-amount">
                    {{ "not_payed" | transloco }} :
                    {{ element.remaining }}
                  </div>
                  }

                </div>

                } @else {

                <!-- Normal Status -->
                <div class="bb-order-status-card" [ngClass]="{
             'pending': element.order_status == 1,
             'approved': element.order_status == 2,
             'rejected': element.order_status == 3,
             'ontheway': element.order_status == 4,
             'shipped': element.order_status == 5,
             'deferred': element.order_status == 6,
             'notcontact': element.order_status == 7,
             'delivered': element.order_status == 8
           }">

                  <div class="bb-order-status-header">

                    <ng-container [ngSwitch]="element.order_status">
                      <span *ngSwitchCase="1">{{ "pending" | transloco }}</span>
                      <span *ngSwitchCase="2">{{ "approved" | transloco }}</span>
                      <span *ngSwitchCase="3">
                        {{ "rejectedreason" | transloco }}
                        @if (element.reason) {
                        : {{ element.reason }}
                        }
                      </span>
                      <span *ngSwitchCase="4">{{ "on the way" | transloco }}</span>
                      <span *ngSwitchCase="5">{{ "shipped" | transloco }}</span>
                      <span *ngSwitchCase="6">{{ "Deferred" | transloco }}</span>
                      <span *ngSwitchCase="7">{{ "notcontacttheclient" | transloco }}</span>
                      <span *ngSwitchCase="8">{{ "delivered" | transloco }}</span>
                    </ng-container>

                  </div>

                  @if (element.comment) {
                  <div class="bb-order-status-comment">
                    {{ element.comment }}
                  </div>
                  }

                  @if (element.order_status == 5) {
                  <div class="bb-order-payment-type">
                    {{ "payment_type" | transloco }} :
                    <span [ngSwitch]="element.payment_type">
                      <span *ngSwitchCase="'0'">{{ "cash" | transloco }}</span>
                      <span *ngSwitchCase="'1'">{{ "vodafone cash" | transloco }}</span>
                      <span *ngSwitchCase="'2'">{{ "instapay" | transloco }}</span>
                      <span *ngSwitchCase="'3'">{{ "online payment" | transloco }}</span>
                      <span *ngSwitchCase="'4'">{{ "bank transfer" | transloco }}</span>
                      <span *ngSwitchCase="'5'">{{ "credit" | transloco }}</span>
                    </span>
                  </div>
                  }

                  @if (element.remaining > 0) {
                  <div class="bb-badge bb-badge-danger bb-order-remaining-amount">
                    {{ "not_payed" | transloco }} :
                    {{ element.remaining }}
                  </div>
                  }

                </div>

                }

              </td>
            </ng-container>

            <!-- Actions Column -->
            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef class="mat-header-cell-custom"></th>
              <td mat-cell *matCellDef="let element" class="mat-cell-custom">
                <div class="dropdown bb-action-dropdown bb-order-action-dropdown">
                  <button class="bb-icon-btn action-btn menu" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown"
                    aria-expanded="false" title="{{ 'Actions' | transloco }}">
                    <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
                      <circle cx="12" cy="5" r="2" />
                      <circle cx="12" cy="12" r="2" />
                      <circle cx="12" cy="19" r="2" />
                    </svg>
                  </button>

                  <ul class="bb-dropdown-menu dropdown-menu dropdown-menu-end bb-order-action-menu"
                    aria-labelledby="dropdownMenuButton1">

                    @if (!isAdmin && element.order_status == 5 && element.pyments?.[0]?.complated == 0) {
                    @if (element.pyments[0]?.requested == 0) {
                    <li>
                      <a class="bb-dropdown-item dropdown-item" (click)="requestYourCommission(element.id)">
                        <span class="bb-order-action-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M12 1v22" />
                            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7H14.5a3.5 3.5 0 0 1 0 7H6" />
                          </svg>
                        </span>
                        {{ "request your commission" | transloco }}
                      </a>
                    </li>
                    }
                    }

                    <li>
                      <a class="bb-dropdown-item dropdown-item" (click)="details(element.id,element.is_from_client)">
                        <span class="bb-order-action-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M1 12s4-7 11-7 11 7 11 7-4 7-11 7S1 12 1 12z" />
                            <circle cx="12" cy="12" r="3" />
                          </svg>
                        </span>
                        {{ "order details" | transloco }}
                      </a>
                    </li>

                    @if (showAdminContent) {

                    @if (element.order_status != '5') {

                    <li *ngIf="warehouseTypeService.isCompany()">
                      <a class="bb-dropdown-item dropdown-item" (click)="addToDeliveryOrders(element)">
                        <span class="bb-order-action-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <rect x="1" y="3" width="15" height="13" rx="2" />
                            <path d="M16 8h4l3 3v5h-7z" />
                            <circle cx="5.5" cy="18.5" r="1.5" />
                            <circle cx="18.5" cy="18.5" r="1.5" />
                          </svg>
                        </span>
                        {{ "ready for delivery" | transloco }}
                      </a>
                    </li>

                    <li *ngIf="warehouseTypeService.isCompany()">
                      <a class="bb-dropdown-item dropdown-item" *ngIf="element.order_status != '2' && element.order_status != '4'"
                        (click)="changeorderstatus(element.id, '2')">
                        <span class="bb-order-action-icon success">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2.4">
                            <path d="M20 6L9 17l-5-5" />
                          </svg>
                        </span>
                        {{ "accept" | transloco }}
                      </a>
                    </li>

                    <li *ngIf="!isSubAdmin">
                      <a class="bb-dropdown-item dropdown-item" *ngIf="element.order_status != '3'" (click)="rejectorder(element.id)">
                        <span class="bb-order-action-icon danger">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2.4">
                            <path d="M18 6L6 18" />
                            <path d="M6 6l12 12" />
                          </svg>
                        </span>
                        {{ "reject" | transloco }}
                      </a>
                    </li>

                    <li *ngIf="warehouseTypeService.isCompany()">
                      <a class="bb-dropdown-item dropdown-item" *ngIf="element.order_status != '4'"
                        (click)="changeorderstatus(element.id, '4')">
                        <span class="bb-order-action-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M5 12h14" />
                            <path d="M13 6l6 6-6 6" />
                          </svg>
                        </span>
                        {{ "on the way" | transloco }}
                      </a>
                    </li>

                    <li *ngIf="warehouseTypeService.isCompany()">
                      <a class="bb-dropdown-item dropdown-item" *ngIf="element.order_status != '3'"
                        (click)="changeorderstatus(element.id, '6')">
                        <span class="bb-order-action-icon warning">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <circle cx="12" cy="12" r="10" />
                            <path d="M12 6v6l4 2" />
                          </svg>
                        </span>
                        {{ "Deferred" | transloco }}
                      </a>
                    </li>

                    <li *ngIf="warehouseTypeService.isCompany()">
                      <a class="bb-dropdown-item dropdown-item" *ngIf="element.order_status != '3'"
                        (click)="changeorderstatus(element.id, '7')">
                        <span class="bb-order-action-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M17 17H7a4 4 0 0 1 0-8h10a4 4 0 0 1 0 8z" />
                            <path d="M8 9V7a4 4 0 0 1 8 0v2" />
                          </svg>
                        </span>
                        {{ "notcontacttheclient" | transloco }}
                      </a>
                    </li>

                    <li *ngIf="warehouseTypeService.isCompany()">
                      <a class="bb-dropdown-item dropdown-item" *ngIf="element.order_status != '3'"
                        (click)="changeorderstatus(element.id, '8')">
                        <span class="bb-order-action-icon success">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2.4">
                            <path d="M20 6L9 17l-5-5" />
                          </svg>
                        </span>
                        {{ "delivered" | transloco }}
                      </a>
                    </li>

                    <li *ngIf="warehouseTypeService.isCompany()">
                      <a class="bb-dropdown-item dropdown-item" *ngIf="element.order_status == '4'"
                        (click)="addDeliveryHero(element.id)">
                        <span class="bb-order-action-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M5 17h14" />
                            <path d="M7 17V7h10v10" />
                            <path d="M9 7l3-3 3 3" />
                          </svg>
                        </span>
                        {{ "add delivery Hero" | transloco }}
                      </a>
                    </li>
                    @if (isAdmin && warehouseTypeService.isWarehouse()) {
                    <li>
                      <a class="bb-dropdown-item dropdown-item" (click)="accStatement(element.phone_number)">
                        <span class="bb-order-action-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M3 3v18h18" />
                            <path d="M7 15l3-3 3 2 4-5" />
                          </svg>
                        </span>
                        {{ "accountStatement" | transloco }}
                      </a>
                    </li>
                    }
                    <li>
                      <a class="bb-dropdown-item dropdown-item" *ngIf="element.order_status != '4'"
                        (click)="showDiscount(element.id, element.total)">
                        <span class="bb-order-action-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <circle cx="8.5" cy="8.5" r="2.5" />
                            <circle cx="15.5" cy="15.5" r="2.5" />
                            <path d="M18 6L6 18" />
                          </svg>
                        </span>
                        {{ "discount" | transloco }}
                      </a>
                    </li>

                    <li *ngIf="!isSubAdmin">
                      <a class="bb-dropdown-item dropdown-item" (click)="changeorderstatus(element.id, '5', '', element.total)">
                        <span class="bb-order-action-icon success">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2.4">
                            <path d="M20 6L9 17l-5-5" />
                          </svg>
                        </span>
                        {{ "complated" | transloco }}
                      </a>
                    </li>

                    <li *ngIf="warehouseTypeService.isCompany() || warehouseTypeService.isWarehouse()">
                      <a class="bb-dropdown-item dropdown-item" (click)="showPopUpPartiallyCompleted(element)">
                        <span class="bb-order-action-icon warning">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M12 2v20" />
                            <path d="M2 12h20" opacity=".35" />
                          </svg>
                        </span>
                        {{ "Partially completed" | transloco }}
                      </a>
                    </li>
                    }

                    <li>
                      <a class="bb-dropdown-item dropdown-item"
                        *ngIf="element.order_status == '5' && element.remaining > 0 && (isAdmin || isSubAdmin)"
                        (click)="addremaining(element.paid, element.remaining, element.id)">
                        <span class="bb-order-action-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M12 1v22" />
                            <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7H14.5a3.5 3.5 0 0 1 0 7H6" />
                          </svg>
                        </span>
                        {{ "changeCredit" | transloco }}
                      </a>
                    </li>

                    <li>
                      <a class="bb-dropdown-item dropdown-item" (click)="quickInvoice(element.id)">
                        <span class="bb-order-action-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M6 2h9l5 5v15H6z" />
                            <path d="M15 2v5h5" />
                            <path d="M9 13h6" />
                            <path d="M9 17h6" />
                            <path d="M9 9h2" />
                          </svg>
                        </span>
                        {{ "Print" | transloco }}
                      </a>
                    </li>

                    <li *ngIf="warehouseTypeService.isCompany()">
                      <a class="bb-dropdown-item dropdown-item" (click)="getUserItems(element.user_id)">
                        <span class="bb-order-action-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M20 21a8 8 0 0 0-16 0" />
                            <circle cx="12" cy="7" r="4" />
                          </svg>
                        </span>
                        {{ "user info" | transloco }}
                      </a>
                    </li>

                    <li *ngIf="isAdmin">
                      <hr class="dropdown-divider">
                    </li>

                    <li *ngIf="isAdmin">
                      <a class="bb-dropdown-item dropdown-item text-danger bb-text-danger" (click)="deleteOrder(element.id, element.order_status)">
                        <span class="bb-order-action-icon danger">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M3 6h18" />
                            <path d="M8 6V4h8v2" />
                            <path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" />
                            <path d="M10 11v6" />
                            <path d="M14 11v6" />
                          </svg>
                        </span>
                        {{ "Delete" | transloco }}
                      </a>
                    </li>
                    }



                    @if (isDeliveryHero) {
                    @if (+element.delivery_status === 0) {
                    <li>
                      <a class="bb-dropdown-item dropdown-item" (click)="changeDeliveryStatus(element.id, 1, element.warehouse_id)">
                        <span class="bb-order-action-icon">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2">
                            <path d="M12 5v14" />
                            <path d="M5 12h14" />
                          </svg>
                        </span>
                        {{ "start" | transloco }}
                      </a>
                    </li>
                    }

                    @if (+element.delivery_status === 1) {
                    <li>
                      <a class="bb-dropdown-item dropdown-item" (click)="changeDeliveryStatus(element.id, 2, element.warehouse_id)">
                        <span class="bb-order-action-icon danger">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2.4">
                            <path d="M18 6L6 18" />
                            <path d="M6 6l12 12" />
                          </svg>
                        </span>
                        {{ "not delivered" | transloco }}
                      </a>
                    </li>

                    <li>
                      <a class="bb-dropdown-item dropdown-item"
                        (click)="changeDeliveryStatus(element.id, 3, element.warehouse_id, element.total)">
                        <span class="bb-order-action-icon success">
                          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                            stroke-width="2.4">
                            <path d="M20 6L9 17l-5-5" />
                          </svg>
                        </span>
                        {{ "delivered" | transloco }}
                      </a>
                    </li>
                    }
                    }
                  </ul>
                </div>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns" class="mat-header-row-custom"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;" class="mat-row-custom"></tr>
          </table>
      </div>

      <mat-paginator
        class="bb-paginator" [length]="stockTotal" [pageSize]="10" (page)="onPaginateChange($event)">
      </mat-paginator>
    </div>

    @if (noData) {
    <div class="bb-empty-state">
      <app-nodata></app-nodata>
    </div>
    }
  </div>
</div>

<!-- User Info Popup -->
<div *ngIf="showPopUp" class="bb-modal-backdrop">
  <div class="bb-modal-card bb-order-modal-card">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="120" height="120" class="bb-order-modal-icon">

      <!-- Head -->
      <circle cx="32" cy="22" r="10" fill="currentColor" />

      <!-- Body -->
      <path d="M12 54c0-12 10-18 20-18s20 6 20 18" fill="currentColor" />

    </svg>
    <div class="bb-order-user-head">
      <img class="bb-order-profile-img" [src]="userimage" alt="" />
      <h5 class="bb-text-muted">
        {{ 'Name' | transloco }} : {{ userfirstname }}
      </h5>
    </div>

    <div class="bb-order-user-info">
      <p>{{ 'username' | transloco }} : {{ userName }}</p>
      <p>{{ 'phone' | transloco }} : 0{{ userPhone }}</p>
      <p>
        <a [href]="userInstgram">{{ 'instagram' | transloco }}</a> --
        <a [href]="userFacebook">{{ 'facebook' | transloco }}</a> --
        <a [href]="userTiktok">{{ 'tiktok' | transloco }}</a>
      </p>
    </div>

    <button (click)="close()" class="bb-btn bb-btn-secondary">
      {{ "close" | transloco }}
    </button>

  </div>
</div>
<!-- Reject Popup -->
<div *ngIf="showRejectPopUp" class="bb-modal-backdrop">
  <div class="bb-modal-card bb-order-modal-card">

    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="120" height="120" class="bb-order-modal-icon">
      <!-- Circle -->
      <circle cx="32" cy="32" r="30" fill="currentColor" />

      <!-- X mark -->
      <line x1="20" y1="20" x2="44" y2="44" stroke="#ffffff" stroke-width="6" stroke-linecap="round" />
      <line x1="44" y1="20" x2="20" y2="44" stroke="#ffffff" stroke-width="6" stroke-linecap="round" />
    </svg>

    <div class="bb-form-grid">
      <div class="bb-field">
        <label class="bb-label" for="rejection">
          {{ "rejectedreason" | transloco }}
        </label>
        <input class="bb-input" type="text" id="rejection" [(ngModel)]="reason"
          placeholder="{{ 'rejectedreason' | transloco }}" />
      </div>
    </div>

    <button (click)="onSubmit()" type="submit" class="bb-btn bb-btn-primary">
      {{ "Submit" | transloco }}
    </button>

    <button (click)="close()" class="bb-btn bb-btn-secondary">
      {{ "close" | transloco }}
    </button>

  </div>
</div>
<!-- Comment Popup -->
<div *ngIf="showCommentPopUp" class="bb-modal-backdrop">
  <div class="bb-modal-card bb-order-modal-card">

    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="120" height="120" class="bb-order-modal-icon">

      <!-- Bubble -->
      <path d="M10 14c0-4 3-6 6-6h32c3 0 6 2 6 6v20c0 4-3 6-6 6H26l-10 8v-8h-2c-3 0-6-2-6-6V14z" fill="currentColor" />

      <!-- Dots -->
      <circle cx="24" cy="26" r="3" fill="#ffffff" />
      <circle cx="32" cy="26" r="3" fill="#ffffff" />
      <circle cx="40" cy="26" r="3" fill="#ffffff" />

    </svg>

    <div class="bb-form-grid">
      <div class="bb-field">
        <label class="bb-label" for="comment">
          {{ "add comment" | transloco }}
        </label>
        <input class="bb-input" type="text" id="comment" [(ngModel)]="comment"
          placeholder="{{ 'comment placeholder' | transloco }}" />
      </div>
    </div>

    <button (click)="updateComment()" type="submit" class="bb-btn bb-btn-primary">
      {{ "Submit" | transloco }}
    </button>

    <button (click)="close()" class="bb-btn bb-btn-secondary">
      {{ "close" | transloco }}
    </button>

  </div>
</div>

<!-- Discount Popup -->
<div *ngIf="showDiscountPopUp" class="bb-modal-backdrop">
  <div class="bb-modal-card bb-order-modal-card">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" class="bb-order-modal-icon" width="120" height="120"
      fill="none" stroke="currentColor" stroke-width="5" stroke-linecap="round" stroke-linejoin="round">

      <!-- Percent Line -->
      <line x1="20" y1="44" x2="44" y2="20" />

      <!-- Top Circle -->
      <circle cx="24" cy="24" r="6" />

      <!-- Bottom Circle -->
      <circle cx="40" cy="40" r="6" />

    </svg>

    <div class="bb-form-grid">
      <div class="bb-field">
        <label class="bb-label" for="discount">
          {{ 'discount' | transloco }}
        </label>
        <input class="bb-input" type="number" id="discount" [(ngModel)]="discount"
          placeholder="{{ 'discount value' | transloco }}" />
      </div>
    </div>

    <button (click)="addDiscount()" type="submit" class="bb-btn bb-btn-primary">
      {{ "Submit" | transloco }}
    </button>

    <button (click)="close()" class="bb-btn bb-btn-secondary">
      {{ "close" | transloco }}
    </button>

  </div>
</div>

<!-- Delivery Hero Popup -->
<div *ngIf="showDeliveryHeroPopUp" class="bb-modal-backdrop">
  <div class="bb-modal-card bb-order-modal-card">

    <img src="/assets/ontheway.png" class="bb-order-modal-icon" />

    <div class="bb-form-grid">
      <div class="bb-field">
        <div class="bb-field dropdown-container">
          <label class="bb-label" for="deliveryHero">
            {{ "add delivery Hero" | transloco }}
          </label>

          <select class="bb-select" id="deliveryHero" [(ngModel)]="deliveryHero" [ngModelOptions]="{ standalone: true }"
            (change)="onDeliveryHeroChange()">

            <option [ngValue]="null" disabled>
              {{ 'select' | transloco }}
            </option>

            <option *ngFor="let hero of deliveryHeros" [ngValue]="hero">
              {{ hero.name }}
            </option>

          </select>
        </div>
      </div>
    </div>

    <button (click)="addHero()" type="submit" class="bb-btn bb-btn-primary">
      {{ "Submit" | transloco }}
    </button>

    <button (click)="close()" class="bb-btn bb-btn-secondary">
      {{ "close" | transloco }}
    </button>

  </div>
</div>

<!-- Partially Completed Popup -->
<div *ngIf="showPartCompPopUp" class="bb-modal-backdrop">
  <div class="bb-modal-card bb-order-modal-card">
    <svg class="bb-order-modal-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64" width="120" height="120"
      fill="none" stroke="currentColor" stroke-width="4" stroke-linecap="round" stroke-linejoin="round">

      <!-- Partial Circle -->
      <path d="M32 8
           A24 24 0 1 1 8 32" />

      <!-- Check -->
      <polyline points="22 34 30 42 44 26" />

    </svg>
    <div class="bb-form-grid">
      <div class="bb-field">

        <table class="bb-order-partial-table">
          <thead>
            <tr>
              <th>{{ 'Product' | transloco }}</th>
            </tr>
          </thead>

          <tbody>
            <tr *ngFor="let item of selectedProductsDetails">
              <td class="bb-order-partial-cell">
                {{ item.item }}<br>

                <input class="bb-input" type="number" min="1" [max]="item.quantity" [(ngModel)]="item.quantity"
                  name="quantity_{{ item.product_id }}" placeholder="{{ 'quantity' | transloco }}" />

                <input *ngIf="item.bounes != 0" class="bb-input" type="number" min="1" [max]="item.bounes" [(ngModel)]="item.bounes"
                  name="bounes_{{ item.product_id }}" placeholder="{{ 'bounes' | transloco }}" />

                <input class="bb-input" type="number" min="0" [disabled]="true" [(ngModel)]="item.price"
                  name="price_{{ item.product_id }}" placeholder="{{ 'price' | transloco }}" />
              </td>
            </tr>
          </tbody>

        </table>

      </div>
    </div>

    <button (click)="partialComplated()" type="submit" class="bb-btn bb-btn-primary">
      {{ "Submit" | transloco }}
    </button>

    <button (click)="close()" class="bb-btn bb-btn-secondary">
      {{ "close" | transloco }}
    </button>

  </div>
</div>

<!-- Payment Popup -->
<div *ngIf="showPaymentPopUp" class="bb-modal-backdrop">
  <div class="bb-modal-card bb-order-modal-card">

    <div class="bb-form-grid">

      @if (!changeRemaining) {
      <div class="bb-field bb-field-full bb-text-center">
        <img src="/assets/income.png" class="bb-mb-16" />

        <select class="bb-select" [(ngModel)]="payment_type">
          <option value="0">{{ "cash" | transloco }}</option>
          <option value="1">{{ "vodafone cash" | transloco }}</option>
          <option value="2">{{ "instapay" | transloco }}</option>
          <option value="3">{{ "online payment" | transloco }}</option>
          <option value="4">{{ "bank transfer" | transloco }}</option>
          <option value="5">{{ "credit" | transloco }}</option>
        </select>
      </div>
      }

      @if (payment_type == '5' || changeRemaining) {
      <div class="bb-field">
        <input class="bb-input" type="text" placeholder="{{ 'payed' | transloco }}" [(ngModel)]="payed" />
      </div>

      <div class="bb-field">
        <input class="bb-input" type="text" placeholder="{{ 'not_payed' | transloco }}" [(ngModel)]="not_payed" />
      </div>
      }

    </div>

    <button (click)="changePaymentType()" type="submit" class="bb-btn bb-btn-primary">
      {{ "Submit" | transloco }}
    </button>

    <button (click)="close()" class="bb-btn bb-btn-secondary">
      {{ "close" | transloco }}
    </button>

  </div>
</div>


<!-- Today's Orders Popup -->
<div *ngIf="showtodaysorders" class="bb-modal-backdrop">
  <div class="bb-modal-card bb-order-modal-card bb-order-today-popup">

    <svg
      class="bb-order-today-icon"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      width="70"
      height="70"
      fill="none"
      stroke="currentColor"
      stroke-width="3.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <rect x="10" y="14" width="44" height="40" rx="4" />
      <line x1="10" y1="24" x2="54" y2="24" />
      <line x1="20" y1="10" x2="20" y2="18" />
      <line x1="44" y1="10" x2="44" y2="18" />
      <line x1="20" y1="34" x2="44" y2="34" />
      <line x1="20" y1="42" x2="38" y2="42" />
    </svg>

    <h4 class="bb-order-today-title">
      {{ "todays orders" | transloco }}
    </h4>

    <div class="bb-order-today-list">
      <div *ngFor="let item of todaysOrders" class="bb-card bb-order-today-item">
        <p (click)="getTodaysOrders(item.orders_ids)">
          {{ item.name }}
        </p>
      </div>
    </div>

    <button (click)="close()" class="bb-btn bb-btn-secondary">
      {{ "close" | transloco }}
    </button>

  </div>
</div>

<!-- Quick Invoice Popup -->
<div *ngIf="showQuickInvoice" class="bb-modal-backdrop">
  <div class="bb-order-quick-invoice-shell maindev">
    <button (click)="close()" class="bb-btn bb-btn-secondary noPrint bb-order-quick-close">{{ 'close' | transloco }}</button>
    <app-invoice [orderid]="selectedOrderId"></app-invoice>
  </div>
</div>
